import { ZoneMinderContext } from "app/context/ZoneMinderContext";
import { useContext } from "react";

export function useZoneMinderToken() {
    const context = useContext(ZoneMinderContext);

    return context.token;
}
